// extracted by mini-css-extract-plugin
export var numpadContainer = "_p7-1";
export var phoneButton = "_p7-0";